import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_DENIAL_RESPONSE_LIST = "GET_DENIAL_RESPONSE_LIST";

export const service = async (facsLogId) => {
  const options: object = {
    url: `/api/DenialsPredictor/GetDenialResponseList/` + facsLogId,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_DENIAL_RESPONSE_LIST, service, mock);
